// extracted by mini-css-extract-plugin
export default {"ActionsContainer":"Bookmarks_ActionsContainer__E1eO-"};